import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import NumberFormat, { NumberFormatProps } from 'react-number-format';

interface NumberFormatCustomProps extends NumberFormatProps {
  unit?: string;
  fixedDecimalScale?: boolean;
  onChange?: (value: any) => void;
  inputRef?: React.Ref<any>;
}

const useStyles = makeStyles({
  quantityInputContainer: {
    '& input': {
      textAlign: 'right',
    },
  },
});
export type TextFieldCustomProps = Partial<TextFieldProps> & NumberFormatCustomProps;

function NumberFormatCustom(props: NumberFormatCustomProps) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange?.(values.value);
      }}
      decimalSeparator=","
      decimalScale={3}
      fixedDecimalScale={props.fixedDecimalScale ?? true}
      isNumericString
      suffix={` ${props.unit ?? 't'}`}
      allowNegative={false}
    />
  );
}

const WeightInputField: React.FC<TextFieldCustomProps> = ({ InputProps, unit, fixedDecimalScale, ...rest }) => {
  const classes = useStyles();
  const inputProps = InputProps ? InputProps.inputProps : {};

  return (
    <TextField
      InputProps={{
        ...InputProps,
        inputComponent: NumberFormatCustom as any,
        inputProps: { unit, fixedDecimalScale, ...inputProps },
      }}
      className={classes.quantityInputContainer}
      {...rest}
    />
  );
};

export default WeightInputField;
